import {useQuery} from '@apollo/react-hooks';

import type {EntityType} from 'nutshell-graphql-types';
import type {
    GetFields as GetFieldsQuery,
    GetFieldsVariables as GetFieldsQueryVariables,
} from 'nutshell-graphql-types';

import GET_FIELDS from './graphql/queries/get-fields.graphql';

export const useGetSelectedFields = (entityType: EntityType) => {
    const {data, loading, refetch} = useQuery<GetFieldsQuery, GetFieldsQueryVariables>(GET_FIELDS, {
        variables: {entityType},
        fetchPolicy: 'cache-and-network',
    });

    const createModalFields = data ? data.createModalFields : null;

    return {fields: createModalFields ? createModalFields : [], loading, refetch};
};
